"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionFromObj = void 0;
var utils_1 = require("../../utils");
function removeEmpty(obj) {
    Object.keys(obj).forEach(function (key) {
        if (!obj[key]) {
            delete obj[key];
        }
    });
    return obj;
}
function sectionFromObj(obj) {
    var pageAreas = {};
    return {
        pages: obj.pages || [],
        pageAreas: (removeEmpty(obj.pageAreas || {})),
        startSec: obj.start ? utils_1.stringToSecs(obj.start) : obj.startSec,
        endSec: obj.end ? utils_1.stringToSecs(obj.end) : obj.endSec
    };
}
exports.sectionFromObj = sectionFromObj;
